import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d482cb5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "authentication-login-group" }
const _hoisted_2 = { class: "side" }
const _hoisted_3 = { class: "side-text-wrap" }
const _hoisted_4 = { href: "/" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "switch" }
const _hoisted_7 = {
  class: "text-uppercase",
  style: {"margin-right":"18px"}
}
const _hoisted_8 = {
  class: "text-uppercase",
  style: {"margin-left":"5px"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "auth-language-dropdown" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "sub-title" }
const _hoisted_13 = { class: "mb-6" }
const _hoisted_14 = { class: "label required mb-1" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "mb-6" }
const _hoisted_18 = { class: "d-flex justify-content-between" }
const _hoisted_19 = { class: "label required mb-1" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "forgot" }
const _hoisted_25 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_26 = { class: "d-flex justify-content-between" }
const _hoisted_27 = { class: "label required mb-1" }
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_31 = { class: "msg_1" }
const _hoisted_32 = { class: "msg_2" }
const _hoisted_33 = { class: "mobil-switch" }
const _hoisted_34 = {
  class: "text-uppercase",
  style: {"margin-right":"18px"}
}
const _hoisted_35 = {
  class: "text-uppercase",
  style: {"margin-left":"5px"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import axios from "axios";
import * as Yup from "yup";
import { useStore } from "@/store";
import { useRouter, useRoute } from "vue-router";
import { ref, onMounted, inject, provide, computed } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import JwtService from "@/core/services/JwtService";
import { ErrorMessage, Field, Form } from "vee-validate";
import AuthSwitch from "../../components/AuthSwitch.vue";
import LanguageDropdown from "../../components/LanguageDropdown.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import i18n from "@/core/plugins/i18n";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import { LanguageTypes } from "@/core/types/LanguageTypes";
import { useI18n } from "vue-i18n";
import ApiService from "@/core/services/ApiService";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import ForgetPasswordForm from "../../components/signIn/ForgetPasswordForm.vue";
import EmailVerifyPage from "../../components/signIn/EmailVerifyPage.vue";
import SelectTenantPage from "../../components/signIn/SelectTenantPage.vue";
import { isMobile } from "@/core/config/WindowConfig";
import { getTenantLogo, getTenancy, tenancies } from "@/core/types/TenantTypes";
import { SiteTypes } from "@/core/types/SiteTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'SignIn',
  setup(__props) {

const i18nLang = useI18n();
const store = useStore();
const router = useRouter();
const authType = ref(false);
const passwordShow = ref(false);

const showTwoFaError = ref(false);

// const emailList = ref({
//   2: "info@au.thebcr.com",
//   0: "info@thebcr.com",
//   6: "info@isec.jp",
// });

const emailList = ref({
  [SiteTypes.Australia]: "info@au.thebcr.com",
  [SiteTypes.Default]: "info@thebcr.com",
});

const getFlagEmail = computed(() => {
  if (getTenancy.value == tenancies.jp) {
    return "info@isec.jp";
  }
  if (getTenancy.value == tenancies.au) {
    return emailList.value[SiteTypes.Australia];
  }
  return emailList.value[c.value[0]] || "info@thebcr.com";
});

const showPage = ref("LoginPage");
const isSubmitting = ref(false);
const formData = ref<any>({});
const tenantsOptions = ref([]);
const selectedTenant = ref<any>(null);
const twoFaRequired = ref(false);
const twoFaCode = ref<any>(null);

provide("showPage", showPage);
provide("formData", formData);
provide("isSubmitting", isSubmitting);
provide("tenantsOptions", tenantsOptions);
provide("selectedTenant", selectedTenant);
provide("twoFaRequired", twoFaRequired);
provide("twoFaCode", twoFaCode);

const wsSignalR = inject(TenantGlobalInjectionKeys.WS_SIGNAL_R);
const c = ref([] as any);

const { t } = i18n.global;

// const siteEmail = process.env.VUE_APP_CONTACT_EMAIL;
const route = useRoute();
const language = ref<any>();
const getC = async () => {
  try {
    if (getTenancy.value == tenancies.jp) {
      c.value[0] = SiteTypes.Japan;
    } else {
      const res = await axios.get("/api/v1/auth/c");
      c.value = res.data;
    }

    window.localStorage.setItem("c", c.value);
  } catch (error) {
    console.error(error);
  }
};
language.value =
  (route.query.lang as string) ?? i18nLang.locale.value ?? LanguageTypes.enUS;

i18nLang.locale.value = language.value;

onMounted(async () => {
  await configTenantId();
  await getC();
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
});

const configTenantId = async () => {
  var tenantId = route.query.tenantId as string;

  if (tenantId) {
    setCookie("tenantId", tenantId, 30);
  }
};
const setCookie = (name: string, value: string, days: number) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

// const oauth2Endpoint = ref("https://accounts.google.com/o/oauth2/v2/auth?");
// oauth2Endpoint.value +=
//   "scope=https%3A//www.googleapis.com/auth/userinfo.email&";
// oauth2Endpoint.value +=
//   "redirect_uri=" + process.env.VUE_APP_GOOGLE_OAUTH_REDIRECT_URL + "&";
// oauth2Endpoint.value += "response_type=token&";
// oauth2Endpoint.value += "prompt=select_account&";
// oauth2Endpoint.value +=
//   "client_id=" + process.env.VUE_APP_GOOGLE_OAUTH_CLIENT_ID;

const login = Yup.object().shape({
  email: Yup.string().email().required().label("Email"),
  password: Yup.string().required().label("Password"),
});

//form submit function
const onSubmitLogin = async () => {
  await store.dispatch(Actions.LOGOUT);
  // Send login request
  var errors = null;
  isSubmitting.value = true;
  const params = setupLoginParams();

  // params.append("code", formData.code);
  var login = await ApiService.postToken("connect/token", params).catch(
    ({ response }) => {
      if (response.data.error != undefined) {
        errors = [response.data.error];
      } else {
        errors = response.data.errors;
      }
    }
  );

  if (errors) {
    errorHandle(errors);
    return;
  }

  var breakPoint = false;

  breakPoint = handleMultipleTenants(login);
  if (breakPoint) {
    return;
  }

  breakPoint = handleTwoFA(login);
  if (breakPoint) {
    return;
  }

  await loginStart(login);

  isSubmitting.value = false;
};

const loginStart = async (login: any) => {
  store.dispatch(Actions.LOGIN, login.data);
  wsSignalR?.setup(JwtService.getToken());
  if (router.currentRoute.value.query.redirect) {
    await router.push(router.currentRoute.value.query.redirect as string);
  } else {
    await router.push({ name: "dashboard" });
  }
};

const handleTwoFA = (login: any) => {
  if (login?.data?.twoFactorRequired == true) {
    twoFaRequired.value = true;
    isSubmitting.value = false;
    return true;
  }
  return false;
};

const handleMultipleTenants = (login: any) => {
  if (login?.data?.hasMultipleTenants == true && selectedTenant.value == null) {
    showPage.value = "SelectTenantPage";
    tenantsOptions.value = login.data.tenantIds;
    isSubmitting.value = false;
    return true;
  }
  return false;
};

function errorHandle(errors: any) {
  if (errors == "__EMAIL_UNCONFIRMED__") {
    if (errors == "__EMAIL_UNCONFIRMED__") {
      showPage.value = "EmailVerifyPage";
    }
  } else if (errors == "__USER_IS_LOCKED_OUT__") {
    MsgPrompt.error(t("error.__USER_IS_LOCKED_OUT__")).then(() => {
      isSubmitting.value = false;
    });
  } else if (errors == "__USER_UNDER_MAINTENANCE__") {
    MsgPrompt.warning(t("error.__USER_UNDER_MAINTENANCE__")).then(() => {
      isSubmitting.value = false;
    });
  } else if (twoFaRequired.value == true) {
    MsgPrompt.error(t("error.verificationFailed")).then(() => {
      isSubmitting.value = false;
    });
  } else {
    MsgPrompt.error(errors).then(() => {
      isSubmitting.value = false;
    });
  }
}

function setupLoginParams() {
  const params = new URLSearchParams();
  params.append("client_id", "api");
  params.append("grant_type", "password");
  params.append("scopes", "api");
  params.append("username", formData.value.email);
  params.append("password", formData.value.password);
  if (selectedTenant.value !== null) {
    params.append("tenantId", selectedTenant.value);
  }
  if (twoFaRequired.value == true) {
    params.append("tf_code", twoFaCode.value);
  }
  return params;
}

provide("onSubmitLogin", onSubmitLogin);

const toggleAuthType = (_authType) => {
  authType.value = _authType;
  router.push({ name: "sign-up", query: router.currentRoute.value.query });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("img", {
            class: "logo",
            src: _unref(getTenantLogo)['src']
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("action.login")), 1),
        _createVNode(AuthSwitch, {
          isEnabled: authType.value,
          color: "#F5BF21",
          onToggleAuthType: toggleAuthType
        }, null, 8, ["isEnabled"]),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("action.register")), 1)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["form-container", _unref(isMobile) ? 'mobile-form-container' : ''])
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          class: "mobile-logo",
          src: _unref(getTenantLogo)['src']
        }, null, 8, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(LanguageDropdown)
      ]),
      (showPage.value == 'ForgetPasswordPage')
        ? (_openBlock(), _createBlock(ForgetPasswordForm, { key: 0 }))
        : _createCommentVNode("", true),
      (showPage.value == 'EmailVerifyPage')
        ? (_openBlock(), _createBlock(EmailVerifyPage, { key: 1 }))
        : _createCommentVNode("", true),
      (showPage.value == 'LoginPage')
        ? (_openBlock(), _createBlock(_unref(Form), {
            key: 2,
            class: "login-form",
            "validation-schema": _unref(login)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("action.login")), 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("title.welcomeToBcr")), 1),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("fields.email")), 1),
                _createVNode(_unref(Field), {
                  modelValue: formData.value.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                  tabindex: "1",
                  class: "form-control form-control-lg form-control-solid",
                  type: "text",
                  name: "email",
                  autocomplete: "off"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
                      name: "email",
                      placeholder: _ctx.$t('tip.pleaseInput'),
                      size: "large",
                      tabindex: "1"
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_unref(ErrorMessage), { name: "email" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("fields.password")), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-solid fa-lg eye-icon", passwordShow.value ? 'fa-eye-slash' : 'fa-eye']),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (passwordShow.value = !passwordShow.value))
                    }, null, 2),
                    (passwordShow.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("action.hide")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("action.show")), 1))
                  ])
                ]),
                _createVNode(_unref(Field), {
                  tabindex: "2",
                  modelValue: formData.value.password,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.password) = $event)),
                  class: "form-control form-control-lg form-control-solid",
                  type: passwordShow.value ? 'text' : 'password',
                  name: "password",
                  autocomplete: "off"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.password,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.password) = $event)),
                      name: "password",
                      placeholder: _ctx.$t('tip.pleaseInput'),
                      size: "large",
                      tabindex: "2",
                      type: passwordShow.value ? 'text' : 'password'
                    }, null, 8, ["modelValue", "placeholder", "type"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "type"]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_unref(ErrorMessage), { name: "password" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("a", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (showPage.value = 'ForgetPasswordPage'))
                  }, _toDisplayString(_ctx.$t("action.forgotPassword")), 1)
                ])
              ]),
              (twoFaRequired.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("fields.twoFactorAuthentication")), 1)
                    ]),
                    _createVNode(_unref(Field), {
                      tabindex: "2",
                      modelValue: twoFaCode.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((twoFaCode).value = $event)),
                      class: "form-control form-control-lg form-control-solid",
                      type: "text",
                      name: "twoFaCode",
                      autocomplete: "off"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: twoFaCode.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((twoFaCode).value = $event)),
                          name: "twoFaCode",
                          placeholder: _ctx.$t('tip.pleaseInput'),
                          size: "large",
                          tabindex: "2",
                          type: "text"
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("fields.pleaseEnterTwoFactorCode")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(LoadingButton, {
                    "is-loading": isSubmitting.value,
                    "save-title": _ctx.$t('action.login'),
                    class: "btn btn-lg w-100 loginBtn",
                    onClick: _withModifiers(onSubmitLogin, ["prevent"])
                  }, null, 8, ["is-loading", "save-title", "onClick"]),
                  _createElementVNode("div", _hoisted_31, [
                    _createTextVNode(_toDisplayString(_ctx.$t("tip.doNotHaveAccount")) + " ", 1),
                    _createVNode(_component_router_link, {
                      to: { path: '/sign-up', query: _ctx.$route.query }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("action.signup")), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("action.login")), 1),
                    _createVNode(AuthSwitch, {
                      isEnabled: authType.value,
                      color: "#F5BF21",
                      onToggleAuthType: toggleAuthType
                    }, null, 8, ["isEnabled"]),
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("action.register")), 1)
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("tip.wantContact")), 1),
                  _hoisted_36,
                  _createVNode(_component_router_link, { to: "/lead-create" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getFlagEmail.value), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"]))
        : _createCommentVNode("", true),
      (showPage.value == 'SelectTenantPage')
        ? (_openBlock(), _createBlock(SelectTenantPage, { key: 3 }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})